import { useDispatch } from "react-redux";
import { uiActions } from "../../store/reducers/ui";

import { Dialog, DialogContent, DialogActions, Grid, Button } from "@mui/material";

export default function CloseConfirmationDialog(props) {
  const { open, requestType } = props;

  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    const value = event.target.value;

    if (value && value === "yes") {
      dispatch(uiActions.closeWidget({ reason, requestType }));
    } else {
      dispatch(uiActions.updateCancelDialogOpen(false));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>Are you sure? Your information will not be saved!</DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Button value="yes" onClick={handleClose}>
            Yes
          </Button>
          <Button value="no" onClick={handleClose} variant="contained">
            No
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
